module.exports = __webpack_public_path__ + "static/media/Daily bonus button small.491f69ca.svg";